import { ButtonOption } from '@components/Button';
import { IconProp } from '@components/Icon';
import { t } from '@lingui/core/macro';

export type SystemAlertType = 'success' | 'warning' | 'error' | 'info';

export interface AlertTypeProps extends React.HTMLAttributes<HTMLDivElement> {
  type: 'success' | 'warning' | 'error' | 'info';
}

export const getTitleByType = (type: SystemAlertType): string =>
  ({
    success: t`Success`,
    warning: t`Warning`,
    error: t`Alert`,
    info: t`Information`,
  })[type];

export const ICONS_BY_TYPE: Record<SystemAlertType, IconProp> = {
  success: 'checkCircleSolid',
  warning: 'exclamationTriangleSolid',
  error: 'exclamationCircleSolid',
  info: 'infoCircleSolid',
};

export const BUTTONS_BY_TYPE: Record<SystemAlertType, ButtonOption> = {
  success: 'successSystemDialog',
  warning: 'warningSystemDialog',
  error: 'errorSystemDialog',
  info: 'infoSystemDialog',
};

export const BUTTONS_BY_TYPE_INVERSE: Record<SystemAlertType, ButtonOption> = {
  success: 'successSystemDialogInverse',
  warning: 'warningSystemDialogInverse',
  error: 'errorSystemDialogInverse',
  info: 'infoSystemDialogInverse',
};
